import R from 'ramda'
import pageLoadSnippets from './pageLoadSnippets'
import loadAnalyticsData from './loadAnalyticsData'

function createPageLoad(pageName, dynamicData) {
  const name = `IT:NL:NCC:Renegocie:MonteSuaProposta:${pageName}`
  const snippet = pageLoadSnippets[pageName]
  const payloadFromSnippet = snippet ? snippet(dynamicData) : {}

  const getCleanedUrlToGa = () => {
    const params = new URLSearchParams(window.location.search)
    const step = `${params.get('step') ? `?step=${params.get('step')}` : ''}`
    const urlFinal = `${window.location.origin}${window.location.pathname}${step}`

    return urlFinal
  }

  const defaultPayload = {
    site: {
      nome: 'IT',
      ambiente: 'NL',
    },
    page: {
      secao: 'Recovery',
      nome: name,
      url: getCleanedUrlToGa(),
    },
  }

  const payload = R.mergeDeepRight(payloadFromSnippet, defaultPayload)
  loadAnalyticsData(payload)
}

export default createPageLoad
